import { render, staticRenderFns } from "./EditorTinymce.vue?vue&type=template&id=9b1878a0"
import script from "./EditorTinymce.vue?vue&type=script&lang=js"
export * from "./EditorTinymce.vue?vue&type=script&lang=js"
import style0 from "./EditorTinymce.vue?vue&type=style&index=0&id=9b1878a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports